import { Activity, ActivityType } from '@/features/course/admin/types/activity';

export const getActiveDefaultActivityIndex = (activities: Activity[]): number => {
  let activityToActivateId: number | undefined;

  activityToActivateId = activities
    .filter((activity) => activity.type !== ActivityType.Module)
    .sort((a, b) => a.order - b.order)?.[0]?.remoteId;

  if (!activityToActivateId) {
    activityToActivateId = activities
      .filter((activity) => activity.type !== ActivityType.Module)
      .sort((a, b) => a.order - b.order)?.[0]?.remoteId;
  }

  const activityToActivateIndex = activities.findIndex((activity) => activity.remoteId === activityToActivateId);

  return activityToActivateIndex;
};
